<template>
  <div class="ms-select">
    <p>{{ propsFilter.label }}</p>
    <el-select
      v-model="selectValue"
      placeholder="Elije una opción">
      <el-option
        v-for="(option, index) in propsFilter.options"
        :key="index"
        :label="option.label"
        :value="option.value"/>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'MsSelect',
  props: {
    propsFilter: {
      type: Object,
      default: null
    },
    propertyFilter: {
      type: String,
      default: null
    }
  },
  computed: {
    selectValue: {
      get () {
        let _query = this.$route.query
        let statusSelect = null
        statusSelect = _query[this.propertyFilter]
        return statusSelect
      },
      set (value) {
        this.$emit('getFilterValue', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_shared/catalogForm/ms-select.vue